import {
    FETCH_ADJUSTMENTS_REQUEST,
    FETCH_ADJUSTMENTS_SUCCESS,
    FETCH_ADJUSTMENTS_ERROR,
    HIDE_ADJUSTMENT_LOADER,
    SHOW_ADJUSTMENT_LOADER,
    GENERATE_ADJUSTMENT_REPORT_SUCCESS,
    GENERATE_ADJUSTMENT_REPORT_ERROR,
    GET_ACTIVE_ADJUSTMENT_REPORT_REQUEST,
    GET_ACTIVE_ADJUSTMENT_REPORT_SUCCESS,
    GET_ACTIVE_ADJUSTMENT_REPORT_ERROR,
    DOWNLOAD_ADJUSTMENT_REPORT_REQUEST,
    DOWNLOAD_ADJUSTMENT_REPORT_SUCCESS,
    DOWNLOAD_ADJUSTMENT_REPORT_ERROR,
    RESET_ADJUSTMENT_STATE,
    CREATE_ADJUSTMENT_REQUEST,
    CREATE_ADJUSTMENT_SUCCESS,
    CREATE_ADJUSTMENT_ERROR,
    CREATE_ADJUSTMENT_RESET,
    GENERATE_ADJUSTMENT_REPORT_REQUEST,
} from './adjustments.constants';

export const fetchAdjustmentsRequest = payload => ({
    type: FETCH_ADJUSTMENTS_REQUEST,
    payload,
});

export const fetchAdjustmentsSuccess = payload => ({
    type: FETCH_ADJUSTMENTS_SUCCESS,
    payload,
});

export const fetchAdjustmentsError = payload => ({
    type: FETCH_ADJUSTMENTS_ERROR,
    payload,
});

export const generateReportRequest = payload => ({
    type: GENERATE_ADJUSTMENT_REPORT_REQUEST,
    payload,
});

export const generateReportSuccess = payload => ({
    type: GENERATE_ADJUSTMENT_REPORT_SUCCESS,
    payload,
});

export const generateReportError = payload => ({
    type: GENERATE_ADJUSTMENT_REPORT_ERROR,
    payload,
});

export const getActiveReportRequest = hideLoader => ({
    type: GET_ACTIVE_ADJUSTMENT_REPORT_REQUEST,
    hideLoader,
});

export const getActiveReportSuccess = payload => ({
    type: GET_ACTIVE_ADJUSTMENT_REPORT_SUCCESS,
    payload,
});

export const getActiveReportError = payload => ({
    type: GET_ACTIVE_ADJUSTMENT_REPORT_ERROR,
    payload,
});

export const downloadReportRequest = payload => ({
    type: DOWNLOAD_ADJUSTMENT_REPORT_REQUEST,
    payload,
});

export const downloadReportSuccess = payload => ({
    type: DOWNLOAD_ADJUSTMENT_REPORT_SUCCESS,
    payload,
});

export const downloadReportError = payload => ({
    type: DOWNLOAD_ADJUSTMENT_REPORT_ERROR,
    payload,
});

export const createAdjustmentRequest = payload => ({
    type: CREATE_ADJUSTMENT_REQUEST,
    payload,
});

export const createAdjustmentSuccess = payload => ({
    type: CREATE_ADJUSTMENT_SUCCESS,
    payload,
});

export const createAdjustmentError = payload => ({
    type: CREATE_ADJUSTMENT_ERROR,
    payload,
});

export const createAdjustmentReset = payload => ({
    type: CREATE_ADJUSTMENT_RESET,
});

export const showLoader = () => ({ type: SHOW_ADJUSTMENT_LOADER });

export const hideLoader = () => ({ type: HIDE_ADJUSTMENT_LOADER });

export const resetTxnState = () => ({ type: RESET_ADJUSTMENT_STATE });
